import { TAROT_CORPUS_GENERATED_AT, TAROT_CORPUS_VERSION } from './meta/corpus-version';

export interface TarotCorpusManifest {
  id: 'lilith-arcana-core';
  version: string;
  language: 'it';
  total_cards: 78;
  total_major: 22;
  total_minor: 56;
  suits: ['Bastoni', 'Coppe', 'Spade', 'Denari'];
  modes_supported: Array<'standard' | 'lilith' | 'qliphotic' | 'kabbalistic'>;
  has_library_longform: boolean;
  has_asset_packs: boolean;
  default_asset_pack: string;
  generated_at: string;
}

export const TAROT_CORPUS_MANIFEST: TarotCorpusManifest = {
  id: 'lilith-arcana-core',
  version: TAROT_CORPUS_VERSION,
  language: 'it',
  total_cards: 78,
  total_major: 22,
  total_minor: 56,
  suits: ['Bastoni', 'Coppe', 'Spade', 'Denari'],
  modes_supported: ['standard', 'lilith', 'qliphotic', 'kabbalistic'],
  has_library_longform: true,
  has_asset_packs: true,
  default_asset_pack: 'symbolic-placeholders',
  generated_at: TAROT_CORPUS_GENERATED_AT,
};
